import noImage from '../public/not-image.png';

export const checkImage = (url: string | undefined): string => {
  return url ? url : noImage;
}
